// removed by extract-text-webpack-plugin
module.exports = {"chooseDifficulty":"_3h6G_wyYS1bBfXnfsCjYmH","difficultyVariants":"_22kubSS3vsDhjuGKd6KjrS","variant":"_3Krk8_ITCPPv6VUwDzbwP4","variantPic":"_3KCbDYPQ1T4ZIpqxx0wUzM","easy":"_2iFYDDOXt7SOJ__MtHPrDg","advanced":"Ai712aw0zhypdxAXx0i0x","expert":"_1SMA5D21_8saTgw1Vhq3Kh","active":"aGm0UZiKUissVUsXA47qL","button":"qp8VgaKkFOGPoy0C00ULJ"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/EquipComponents/ChooseDifficulty/index.css
// module id = 257
// module chunks = 0